import { render, staticRenderFns } from "./ListaAnotacionesComponent.vue?vue&type=template&id=2452f2b0&scoped=true&"
import script from "./ListaAnotacionesComponent.vue?vue&type=script&lang=js&"
export * from "./ListaAnotacionesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListaAnotacionesComponent.vue?vue&type=style&index=0&id=2452f2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452f2b0",
  null
  
)

export default component.exports